import type { PendingSavedSearchPayload, SavedReportColumn, SavedReportItem } from '../api/types';
import type { DataStructureTable } from '../api/endpoints';

export const PENDING_SAVED_SEARCH_STORAGE_KEY = 'pendingSavedSearch';
export const PENDING_SAVED_SEARCH_EVENT = 'daater:pending-saved-search';

const toColumnFieldId = (column: SavedReportColumn) => {
  if (!column || typeof column !== 'object') return null;

  const field = column.field;
  if (typeof field === 'string' && field.trim()) {
    return field.trim();
  }

  if (field && typeof field === 'object' && typeof field._id === 'string' && field._id.trim()) {
    return field._id.trim();
  }

  return null;
};

export const buildPendingSavedSearchPayload = (
  report: SavedReportItem,
  tables: DataStructureTable[]
): PendingSavedSearchPayload | null => {
  const tableId = typeof report.tableId === 'string' ? report.tableId.trim() : '';
  if (!tableId || !report.id) return null;

  const table = tables.find(item => item._id === tableId);
  if (!table) return null;

  return {
    reportId: report.id,
    reportName: typeof report.name === 'string' ? report.name : 'Búsqueda guardada',
    tableId,
    datasetId: table.datasetId,
    filters: Array.isArray(report.filters) ? report.filters : [],
    columnFieldIds: Array.isArray(report.columns)
      ? report.columns.map(toColumnFieldId).filter((value): value is string => Boolean(value))
      : [],
    analysis: Array.isArray(report.analysis) ? report.analysis : [],
    detailed: Boolean(report.detailed),
    demoMode: Boolean(report.demoMode),
  };
};

export const loadPendingSavedSearchPayload = (): PendingSavedSearchPayload | null => {
  if (typeof window === 'undefined') return null;

  const raw = window.localStorage.getItem(PENDING_SAVED_SEARCH_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as PendingSavedSearchPayload;
  } catch {
    window.localStorage.removeItem(PENDING_SAVED_SEARCH_STORAGE_KEY);
    return null;
  }
};

export const clearPendingSavedSearchPayload = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(PENDING_SAVED_SEARCH_STORAGE_KEY);
};

export const persistPendingSavedSearchPayload = (payload: PendingSavedSearchPayload) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(PENDING_SAVED_SEARCH_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent(PENDING_SAVED_SEARCH_EVENT));
};
